<!-- @veltra/icons generated sha256:3658691447aca7a9 gen:8 source:src/svg/normal/arrow-left.svg -->
<script setup lang="ts">
defineOptions({ name: 'ArrowLeft' })
</script>
<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16">
    <path
      fill="currentColor"
      d="m9.985 3.986.028.027a.63.63 0 0 1-.011.903L6.918 8l3.084 3.083a.651.651 0 0 1-.92.918l-3.65-3.65a.497.497 0 0 1 0-.704l3.65-3.649a.63.63 0 0 1 .903-.012"
    />
  </svg>
</template>
